import TextInput from "components/form/input/TextInput";
import { GenericParamFields, ParamFormRow } from "entity/Indicador/components/ParamFields";
import AVL from "..";

export function ParamFields({ tipoIndicadorField }) {
    return (
        <GenericParamFields
            name={AVL.field + tipoIndicadorField}
            tabFields={
                <>
                    <ParamFormRow label="Intervalo de Aderência">
                        <TextInput name="intervaloMin" label="Mínimo" type="number" />
                        <TextInput name="intervaloMax" label="Máximo" type="number" />
                    </ParamFormRow>

                    <ParamFormRow label="Metros Lineares por Hectare">
                        <TextInput name="metrosLinearesHectare" label="Valor (Metros)" type="number" />
                    </ParamFormRow>

                    <ParamFormRow label="Meta">
                        <TextInput name="meta" label="Meta (%)" type="number" />
                    </ParamFormRow>
                </>
            }
        />
    );
}
